enum ViewSelectorKey {
  Overall = "Overall",
  BySpecialty = "By Specialty",
  ByCounty = "By County",
  ByState = "By State",
  ByGeocode = "By Geocode",
  NPI = "NPI",
  Specialty = "Specialty",
  Address = "Address",
}

function getViewNameFromKey(resultType: string): ViewSelectorKey {
  switch (resultType?.toLowerCase()) {
    case "overall":
      return ViewSelectorKey.Overall;
    case "byspecialty":
      return ViewSelectorKey.BySpecialty;
    case "bycounty":
      return ViewSelectorKey.ByCounty;
    case "bystate":
      return ViewSelectorKey.ByState;
    case "bygeocode":
      return ViewSelectorKey.ByGeocode;
    case "npi":
    case "bynpistatus":
      return ViewSelectorKey.NPI;
    case "specialty":
    case "byspecialtycount":
      return ViewSelectorKey.Specialty;
    case "address":
    case "byaddresscount":
      return ViewSelectorKey.Address;
    default:
      return undefined;
  }
}

export { getViewNameFromKey, ViewSelectorKey };
